
(function() {
  function initCollectionReadMore() {
    const rteElements = document.querySelectorAll('rte-formatter, .text-block.rte, .collection-description');
    
    rteElements.forEach(container => {
      if (container.dataset.readMoreInitialized === 'true') return;
      
      const fullText = (container.innerText || '').trim();
      // If total text is short, do nothing (keep natural display)
      if (fullText.length <= 250) {
        container.dataset.readMoreInitialized = 'true';
        container.classList.add('collection-desc-short');
        return;
      }

      const contentClone = container.cloneNode(true);
      const h2 = contentClone.querySelector('h2');
      const firstH3 = !h2 ? contentClone.querySelector('h3') : null;
      
      let headerHtml = '';

      if (h2) {
        headerHtml = `<h2 class="collection-desc-h2">${h2.innerHTML}</h2>`;
        const parent = h2.parentElement;
        h2.remove();
        if (parent && parent !== contentClone && parent.innerText.trim() === '') {
          parent.remove();
        }
      } else if (firstH3) {
        headerHtml = `<h2 class="collection-desc-h2">${firstH3.innerHTML}</h2>`;
        const parent = firstH3.parentElement;
        firstH3.remove();
        if (parent && parent !== contentClone && parent.innerText.trim() === '') {
          parent.remove();
        }
      } else {
        const firstP = contentClone.querySelector('p');
        if (firstP && firstP.innerText.trim().length > 30) {
          headerHtml = `<div class="collection-desc-teaser">${firstP.outerHTML}</div>`;
          firstP.remove();
        }
      }

      const innerBodyText = (contentClone.innerText || '').trim();
      const innerBodyHtml = contentClone.innerHTML.trim();

      // If after extracting H2/H3 the remaining text is very short (< 150 chars) and no lists/subheadings, don't collapse
      const hasSubSections = contentClone.querySelector('h3, h4, ul, ol, section');
      if (innerBodyText.length < 150 && !hasSubSections) {
        container.dataset.readMoreInitialized = 'true';
        container.classList.add('collection-desc-short');
        return;
      }

      container.dataset.readMoreInitialized = 'true';
      container.classList.add('collection-desc-ready');

      const newHtml = `
        <div class="collection-desc-header-box">
          ${headerHtml}
          <div class="collection-desc-btn-row">
            <button type="button" class="collection-desc-btn top-btn" aria-expanded="false" aria-controls="collDescAccordion">
              <span class="btn-label">Read more</span>
              <span class="btn-arrow">▾</span>
            </button>
          </div>
        </div>
        <div class="collection-desc-accordion" id="collDescAccordion">
          <div class="collection-desc-accordion-inner">
            <div class="collection-desc-rich-text">
              ${innerBodyHtml}
            </div>
            <div class="collection-desc-btn-row bottom-row">
              <button type="button" class="collection-desc-btn bottom-btn" aria-expanded="true">
                <span class="btn-label">Show less</span>
                <span class="btn-arrow">▴</span>
              </button>
            </div>
          </div>
        </div>
      `;

      container.innerHTML = newHtml;

      const topBtn = container.querySelector('.top-btn');
      const bottomBtn = container.querySelector('.bottom-btn');
      const accordion = container.querySelector('.collection-desc-accordion');

      function toggleState(expand) {
        if (expand) {
          accordion.classList.add('is-open');
          if (topBtn) {
            topBtn.setAttribute('aria-expanded', 'true');
            topBtn.classList.add('is-open');
            topBtn.querySelector('.btn-label').textContent = 'Show less';
            topBtn.querySelector('.btn-arrow').textContent = '▴';
          }
          if (bottomBtn) bottomBtn.setAttribute('aria-expanded', 'true');
        } else {
          accordion.classList.remove('is-open');
          if (topBtn) {
            topBtn.setAttribute('aria-expanded', 'false');
            topBtn.classList.remove('is-open');
            topBtn.querySelector('.btn-label').textContent = 'Read more';
            topBtn.querySelector('.btn-arrow').textContent = '▾';
          }
          if (bottomBtn) bottomBtn.setAttribute('aria-expanded', 'false');

          const h1 = document.querySelector('h1') || container;
          const header = document.querySelector('header, .header-section, [data-section-type="header"]');
          const headerHeight = header ? header.offsetHeight : 80;
          const targetY = h1.getBoundingClientRect().top + window.pageYOffset - (headerHeight + 20);

          window.scrollTo({
            top: Math.max(0, targetY),
            behavior: 'smooth'
          });
        }
      }

      if (topBtn) {
        topBtn.addEventListener('click', (e) => {
          e.preventDefault();
          const isOpen = accordion.classList.contains('is-open');
          toggleState(!isOpen);
        });
      }

      if (bottomBtn) {
        bottomBtn.addEventListener('click', (e) => {
          e.preventDefault();
          toggleState(false);
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionReadMore);
  } else {
    initCollectionReadMore();
  }

  document.addEventListener('shopify:section:load', initCollectionReadMore);
  document.addEventListener('shopify:section:reorder', initCollectionReadMore);
  window.addEventListener('popstate', () => setTimeout(initCollectionReadMore, 300));
})();
